import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';

import queryString from 'query-string';

import template from 'url-template';

import EsmsPage from '../../components/EsmsPage';

import AgentInformationPanel from './AgentInformationPanel';
import AgentActionsPanel from '../../components/AgentActionsPanel';
import DevicesObjectsPanel from './DevicesObjectsPanel';

import AssignAgentModal from '../Modals/AssignAgentModal';
import DeleteAgentModal from '../Modals/DeleteAgentModal';
import RenameAgentModal from '../Modals/RenameAgentModal';
import ResetAgentModal from '../Modals/ResetAgentModal';
import UnAssignAgentModal from '../Modals/UnAssignAgentModal';
import UpdateAgentTimeZoneModal from '../Modals/UpdateAgentTimeZoneModal';
import AgentLinkSiteModal from '../Modals/AgentLinkSiteModal';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as DeviceActions from '../../actions/deviceActions';
import * as CoreActions from '../../actions/coreActions';

const BasAgentsUrl = template.parse('/iothub/basagents{?company}');
const IotHubUrl = template.parse('/iothub{?company}');

class ManageBasAgentPage extends Component {
    state = {
        assignAgentModalOpen:       false,
        deleteAgentModalOpen:       false,
        linkSitesModalOpen:         false,
        renameAgentModalOpen:       false,
        updateTimeZoneModalOpen:    false,
        resetConfirmationModalOpen: false,
        unAssignAgentModalOpen:     false
    }

    async componentDidMount() {
        const {
            fetchBasAgent,
            fetchDevices,
            history,
            resetDevices,
            setProgressBarLoading
        } = this.props;
        const queryStringValues = queryString.parse(history.location.search);

        setProgressBarLoading(true);

        if (queryStringValues.basAgent) {
            const company = queryStringValues.company;
            const basAgent = queryStringValues.basAgent;
            
            const agent = await fetchBasAgent(basAgent);

            if (isEmpty(agent)) {
                this.handleBasAgentsRoute();
            }

            const driverConfiguration = get(agent, 'driverConfiguration', []);
            if (!driverConfiguration.length) {
                setProgressBarLoading(false);
                return;
            }

            const configurationId = driverConfiguration[0].id;
            const basType = driverConfiguration[0].basType;

            if (basType.toLowerCase() === 'notconfigured') {
                setProgressBarLoading(false);
                resetDevices();
                return;
            }

            await fetchDevices(company, basAgent, configurationId, basType);
        } else {
            this.handleBasAgentsRoute();
        }
    }

    handleIotHubRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(IotHubUrl.expand({
            company: queryValues.get('company')
        }));
    }

    handleBasAgentsRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(BasAgentsUrl.expand({
            company: queryValues.get('company')
        }));
    }

    handleToggleAssignAgentModal = toggleState => {
        this.setState(state => ({
            assignAgentModalOpen: toggleState
        }));
    }

    handleToggleUnAssignAgentModal = toggleState => {
        this.setState(state => ({
            unAssignAgentModalOpen: toggleState
        }));
    }

    handleToggleDeleteAgentModal = toggleState => {
        this.setState(state => ({
            deleteAgentModalOpen: toggleState
        }));
    }

    handleToggleRenameAgentModal = toggleState => {
        this.setState(state => ({
            renameAgentModalOpen: toggleState
        }));
    }

    handleToggleTimeZoneModal = toggleState => {
        this.setState(state => ({
            updateTimeZoneModalOpen: toggleState
        }));
    }

    handleToggleResetConfirmationModal = toggleState => {
        this.setState(state => ({
            resetConfirmationModalOpen: toggleState
        }));
    }

    handleToggleSiteLinking = toggleState => {
        this.setState(state => ({
            linkSitesModalOpen: toggleState
        }));
    }

    render() {
        const { selectedAgent, companyInfo, currentScopes } = this.props;

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        if (!selectedAgent) {
            return null;
        }

        return (
            <React.Fragment>
                <EsmsPage
                    child={selectedAgent.name}
                    handlers={[this.handleIotHubRoute, this.handleBasAgentsRoute]}
                    iconSrc="/assets/images/nodesIconColor.svg"
                    parents={[companyInfo.companyName, 'BAS Agents']}
                    sidebar={(<React.Fragment>
                        <AgentInformationPanel agent={selectedAgent} />
                        <AgentActionsPanel
                            isFullHubAllowed={isFullHubAllowed}
                            companyInfo={this.props.companyInfo}
                            history={this.props.history}
                            agent={selectedAgent}
                            toggleAssignAgentModal={this.handleToggleAssignAgentModal}
                            toggleUnAssignAgentModal={this.handleToggleUnAssignAgentModal}
                            toggleDeleteAgentModal={this.handleToggleDeleteAgentModal}
                            toggleRenameAgentModal={this.handleToggleRenameAgentModal}
                            toggleTimeZoneModal={this.handleToggleTimeZoneModal}
                            toggleFactoryResetModal={this.handleToggleResetConfirmationModal}
                            toggleLinkSitesModal={this.handleToggleSiteLinking}
                        />
                    </React.Fragment>)}
                    title="Devices and Objects"
                >
                    <DevicesObjectsPanel
                        history={this.props.history}
                    />
                </EsmsPage>
                <AssignAgentModal
                    open={this.state.assignAgentModalOpen}
                    close={() => this.handleToggleAssignAgentModal(false)}
                    agent={selectedAgent}
                    title={`Assign Agent to ${selectedAgent.name}`}
                />
                <ResetAgentModal
                    open={this.state.resetConfirmationModalOpen}
                    close={() => this.handleToggleResetConfirmationModal(false)}
                    title="Reset Agent Action"
                    agentId={selectedAgent.id}
                    agentName={selectedAgent.name}
                />
                <DeleteAgentModal
                    open={this.state.deleteAgentModalOpen}
                    close={() => this.handleToggleDeleteAgentModal(false)}
                    reroute={this.handleBasAgentsRoute}
                    agentId={selectedAgent.id}
                    agentName={selectedAgent.name}
                    title={`Delete Agent Configuration: ${selectedAgent.name}`}
                />
                <RenameAgentModal
                    open={this.state.renameAgentModalOpen}
                    close={() => this.handleToggleRenameAgentModal(false)}
                    agent={selectedAgent}
                    title={`Rename Agent ${selectedAgent.name}`}
                />
                <UpdateAgentTimeZoneModal
                    open={this.state.updateTimeZoneModalOpen}
                    close={() => this.handleToggleTimeZoneModal(false)}
                    agent={selectedAgent}
                    title={`Update Agent ${selectedAgent.name}'s Time Zone`}
                />
                <UnAssignAgentModal
                    open={this.state.unAssignAgentModalOpen}
                    close={() => this.handleToggleUnAssignAgentModal(false)}
                    agent={selectedAgent}
                    title={`Unassign Agent ${selectedAgent.name}`}
                />
                { this.state.linkSitesModalOpen ? 
                    <AgentLinkSiteModal
                        agentId={selectedAgent.id}
                        title={`Link Sites to ${selectedAgent.name}`}
                        open={this.state.linkSitesModalOpen}
                        close={() => this.handleToggleSiteLinking(false)}
                    /> 
                    : null
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        basAgents:     Object.values(basAgents),
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        devices:       state.device.devices,
        selectedAgent
    };
};

const mapDispatchToProps = {
    ...BasAgentActions,
    ...DeviceActions,
    ...CoreActions,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageBasAgentPage));
